const CDN_ORIGIN = process.env.REACT_APP_CDN_URL
const S3_ORIGIN = process.env.REACT_APP_S3_URL

export const toCdnUrl = (url) => {
  if (!CDN_ORIGIN || !S3_ORIGIN || !url) return url
  return url.replace(S3_ORIGIN, CDN_ORIGIN)
}
